var map = {
	"./audio-muted.svg": 2759,
	"./audio.svg": 7281,
	"./copy.svg": 503,
	"./github.svg": 2986,
	"./language.svg": 161,
	"./video-muted.svg": 691,
	"./video.svg": 5090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;